import { useState, useEffect } from "react";
import { Toaster } from "@/components/ui/toaster";

/**
 * Renders null on the server and on the first client render (so hydration trees match),
 * then mounts the real Toaster after hydration via useEffect.
 */
export function ClientOnlyToaster() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;
  return <Toaster />;
}
